import React from 'react'
import { SwitchInput, SwitchLabel, SwitchButton } from './styles'

const FormSwitch = ({ id, toggled, onChange, marginRight }) => (
  <>
    <SwitchInput
      className="switch-checkbox"
      id={id}
      type="checkbox"
      checked={toggled}
      onChange={onChange}
    />
    <SwitchLabel className="switch-label" htmlFor={id} marginRight={marginRight}>
      <SwitchButton className="switch-button" />
    </SwitchLabel>
  </>
);

export default FormSwitch